<template>
    <div>
        <nav-bar></nav-bar>
        <div class="container">
            <div class="section">
              <nav class="breadcrumb" aria-label="breadcrumbs">
                  <li class="is-active"><a href="#" aria-current="page">{{'Analítica ' + (clientName || '(Todos)')}}</a></li>
              </nav>
              <div class="is-flex is-flex-one-line-container">
                <div class="field no-margin-bottom">
                  <label class="label">Fecha Inicio (00.00h)</label>
                  <input class="input" type="date" placeholder="yyyy-mm-dd" v-model="startDate">
                </div>
                <div class="field no-margin-bottom padding-left-10">
                  <label class="label">Fecha Fin (23.59h)</label>
                  <input class="input" type="date" placeholder="yyyy-mm-dd" v-model="endDate">
                </div>
                <div class="field no-margin-bottom padding-left-10">
                  <div class="button is-danger" @click="reset">
                    <span class="icon"><i class="fas fa-eraser"></i></span>
                    <span class="is-capitalized">Borrar</span>
                  </div>
                </div>
                <div class="field no-margin-bottom padding-left-10">
                  <div class="button is-primary" @click="filter">
                    <span class="icon"><i class="fas fa-search"></i></span>
                    <span class="is-capitalized">Filtrar</span>
                  </div>
                </div>
              </div>

              <br><br>

              <!-- TABS -->
              <div class="tabs is-toggle">
                <ul>
                  <li :class="{'is-active': isActiveTab('messages')}" @click="showTab('messages')">
                    <a>
                      <span class="icon is-small"><i class="fas fa-comment" aria-hidden="true"></i></span>
                      <span>Mensajes</span>
                    </a>
                  </li>

                  <li :class="{'is-active': isActiveTab('platform')}" @click="showTab('platform')">
                    <a>
                      <span class="icon is-small"><i class="fas fa-rss" aria-hidden="true"></i></span>
                      <span>Plataforma</span>
                    </a>
                  </li>

                </ul>
              </div>

              <div v-if="isActiveTab('messages')">

                <table class="table is-striped is-fullwidth">
                  <thead>
                  <tr>
                    <th class="is-capitalized">Mensajes por estado</th>
                    <th class="is-capitalized">Número</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr><td>Mensajes OK</td><td>{{messagesTotal.totalOkMessages}}</td></tr>
                  <tr><td>Mensajes Duda</td><td>{{messagesTotal.totalKoMessages}}</td></tr>
                  <tr><td>Mensajes Error</td><td>{{messagesTotal.totalWithoutRegisterMessages}}</td></tr>
                  <tr><td>Mensajes Descartados</td><td>{{messagesTotal.totalWithoutRegisterDiscardedMessages}}</td></tr>
                  <tr><td>Total Conversaciones</td><td>{{messagesTotal.totalConversations}}</td></tr>
                  <tr><td>Total mensajes</td><td>{{messagesTotal.totaslMessages}}</td></tr>
                  </tbody>
                </table>

                <div v-if="showMessagesPie">
                  <GChart
                    type="PieChart"
                    :data="messageByStatePieData"
                    :options="getChartOptions('Porcentajes por Estado', 'message')"
                  />
                  <hr/>
                </div>

                <div v-if="messageByStateChartData.length>1">
                  <GChart
                    type="ColumnChart"
                    :data="messageByStateChartData"
                    :options="getChartOptions('Evolución por Estado', 'messageChart', true)"
                  />
                  <hr/>
                </div>

                <div v-if="messageByStateChartDataWithoutDiscarded.length>1">
                  <GChart
                    type="ColumnChart"
                    :data="messageByStateChartDataWithoutDiscarded"
                    :options="getChartOptions('Evolución por Estado (eliminando descartados)', 'messageChart', true)"
                  />
                  <hr/>
                </div>

                <div v-if="messageTotalChartData.length>1">
                  <GChart
                    type="ColumnChart"
                    :data="messageTotalChartData"
                    :options="getChartOptions('Evolución por total de mensajes', 'message')"
                  />
                  <hr/>
                </div>

              </div>

              <div v-if="isActiveTab('platform')">

                <table class="table is-striped is-fullwidth">
                  <thead>
                    <tr>
                      <th class="is-capitalized">Plataforma</th>
                      <th class="is-capitalized">Número</th>
                    </tr>
                  </thead>
                    <tbody>
                    <tr :key="index" v-for="(platform, index) in platforms"><td>{{ platform.name }}</td><td>{{platform.count}}</td></tr>
                  </tbody>
                </table>

                <div v-if="platformPieData.length>1">
                  <GChart
                    type="PieChart"
                    :data="platformPieData"
                    :options="getChartOptions('Porcentajes por plataforma', 'platform')"
                  />
                  <hr/>
                </div>

                <div v-if="platformChartData.length>1">
                  <GChart
                    type="ColumnChart"
                    :data="platformChartData"
                    :options="getChartOptions('Evolución por plataforma', 'platform', true)"
                  />
                  <hr/>
                </div>

                <div v-if="platformTotalChartData.length>1">
                  <GChart
                    type="ColumnChart"
                    :data="platformTotalChartData"
                    :options="getChartOptions('Evolución del total de mensajes', 'platform')"
                  />
                  <hr/>
                </div>

              </div>

            </div>
        </div>
    </div>
</template>

<script>

import Auth from '../models/auth'
import { GChart } from 'vue-google-charts'

export default {
  components: {
    GChart
  },
  data () {
    return {
      startDate: null,
      endDate: null,
      activeTab: 'messages',
      chartOptions: {
        width: '100%', height: 500
      },
      client: this.$route.params.client,
      clientName: null,
      kpis: [],
      messages: [],
      messagesTotal: {
        totalConversations: 0,
        totaslMessages: 0,
        totalOkMessages: 0,
        totalKoMessages: 0,
        totalWithoutRegisterMessages: 0,
        totalWithoutRegisterDiscardedMessages: 0
      },
      showMessagesPie: false,
      diagnosticTypes: {no: 1, maybe: 2, yes: 3, urgent: 4},
      botPlatforms: [],
      platformTypes: [],
      platformsColors: null,
      platformsTextColors: null,
      diagnostics: {no: 0, maybe: 0, yes: 0, urgent: 0, total: 0},
      platforms: [],
      // Messages Charts
      messageByLanguagePieData: [],
      messageByStatePieData: [],
      messageByStateChartData: [],
      messageByStateChartDataWithoutDiscarded: [],
      messageTotalChartData: [],
      // Diagnostics Charts
      diagnosticPieData: [],
      diagnosticChartData: [],
      diagnosticTotalChartData: [],
      // Platforms Charts
      platformPieData: [],
      platformChartData: [],
      platformTotalChartData: []
    }
  },
  computed: {
    isAdmin () {
      return Auth.isAdmin()
    }
  },
  created () {
    this.callApi()
    this.breadcrumbDetails()
  },
  methods: {
    breadcrumbDetails () {
      if (this.client) {
        this.api.post('/ClientById/', {idClient: this.client}).then(response => {
          this.clientName = response.client.name
        })
      }
    },
    initPlatforms () {
      this.platforms = []
      this.platformTypes = [
        {
          name: 'Facebook',
          key: 'F',
          color: '#0054ec',
          textColor: '#ffffff'
        },
        {
          name: 'Whatsapp',
          key: ['W', 'WBA', 'WB', 'AW', 'WCA'],
          color: '#268104',
          textColor: '#ffffff'
        },
        {
          name: 'Telegram',
          key: 'T',
          color: '#03a6ff',
          textColor: '#ffffff'
        },
        {
          name: 'Web',
          key: ['C', 'D'],
          color: '#ff6e00',
          textColor: '#ffffff'
        },
        {
          name: 'Xenioo',
          key: 'X',
          color: '#00ff00',
          textColor: '#000000'
        },
        {
          name: 'Android',
          key: 'A',
          color: '#f3021c',
          textColor: '#ffffff'
        },
        {
          name: 'iOS',
          key: 'I',
          color: '#01526b',
          textColor: '#ffffff'
        },
        {
          name: 'Instagram',
          key: 'INS',
          color: '#f455ff',
          textColor: '#ffffff'
        },
        {
          name: 'Teams',
          key: 'BF',
          color: '#9200ec',
          textColor: '#ffffff'
        },
        // {
        //   name: 'MBOT',
        //   key: 'MBOT',
        //   color: '#fce23a',
        //   textColor: '#000000'
        // }
      ]
    },
    callApi () {
      this.initPlatforms()
      this.getTotalMessageData()
      this.getMessageData()
      this.getPlatformData()
    },
    getChartOptions (title, color = 'message', isStacked = false) {
      const colors = {
        message: ['#268104', '#ff6e00', '#f3021c', '#0a3162'],
        messageChart: ['#268104', '#09e14e', '#f3021c', '#0a3162'],
        diagnostic: ['#268104', '#0054ec', '#ff6e00', '#f3021c', '#f6c7b6'],
        platform: this.platformsColors
      }

      const options = {
        width: '100%',
        height: 500,
        title: title,
        colors: colors[color],
        slices: this.platformsTextColors.map(textColor => ({textStyle: {color: textColor}}))
      }

      return isStacked ? {...options, isStacked: 'percent'} : options
    },
    getTotalMessageData () {
      this.api.post('/StadisticsGetList', {from: this.startDate, to: this.endDate, idClient: this.client || 0})
        .then(response => {
          this.messagesTotal = {
            ...response,
            totalOkMessages: response.totaslMessages_OK,
            totalKoMessages: response.totaslMessages_KO,
            totalWithoutRegisterMessages: response.totaslMessages_WithoutRegister,
            totalWithoutRegisterDiscardedMessages: response.totaslMessages_WithoutRegister_Discard
          }
          this.setTotalMessageData()
        })
    },
    getMessageData () {
      this.api.post('/MessagesStadisticsGetList', {from: this.startDate, to: this.endDate, idClient: this.client || 0})
        .then(response => {
          this.messages = response
          this.setMessagesChartData()
        })
    },
    setPlatformTypesAndColors () {
      this.platformTypes = this.platformTypes.filter(platform => this.botPlatforms.some(botPlatforms => platform.key.includes(botPlatforms)))
      this.platformsColors = this.platformTypes.map(platform => platform.color)
      this.platformsTextColors = this.platformTypes.map(platform => platform.textColor)
    },
    getPlatformData () {
      this.api.post('/DataPlatformList', {idClient: this.client}).then(response => {
        this.botPlatforms = response.platforms.map((platform) => platform.value).filter(platform => platform !== '0')
        this.setPlatformTypesAndColors()
        this.api.post('/PlatformStadisticsGetList', {from: this.startDate, to: this.endDate, idClient: this.client || 0})
          .then(response => {
            this.kpis = response
            this.setPlatformData()
          })
      })
    },
    setTotalMessageData () {
      this.messageByStatePieData = [
        ['Estado', 'Número'],
        ['Mensajes OK', this.messagesTotal.totalOkMessages],
        ['Mensajes Duda', this.messagesTotal.totalKoMessages],
        ['Mensajes Error', this.messagesTotal.totalWithoutRegisterMessages],
        ['Mensajes Descartados', this.messagesTotal.totalWithoutRegisterDiscardedMessages]
      ]
      this.showMessagesPie = !!Object.values(this.messagesTotal).reduce((a, b) => a + b)
    },
    setMessagesChartData () {
      this.messageByStateChartData = [['Date', 'Mensajes OK', 'Mensajes Duda', 'Mensajes Error', 'Mensajes Descartados']]
      this.messageByStateChartDataWithoutDiscarded = [['Date', 'Mensajes OK', 'Mensajes Duda', 'Mensajes Error']]
      this.messageTotalChartData = [['Date', 'Total']]

      this.messageByStateChartData = this.messageByStateChartData.concat(this.messages.map(message => [
        message.date,
        message.totalOK,
        message.totalKO,
        message.totalSinRegistro,
        message.totalSinRegistroDescartado
      ]))

      this.messageByStateChartDataWithoutDiscarded = this.messageByStateChartDataWithoutDiscarded.concat(this.messages.map(message => [
        message.date,
        message.totalOK,
        message.totalKO,
        message.totalSinRegistro
      ]))

      this.messageTotalChartData = this.messageTotalChartData.concat(this.messages.map(message => [message.date, message.total]))
    },
    setPlatformData () {
      this.setPlatformsCount()
      this.setPlatformsPieData()
      this.setPlatformsChartData()
    },
    reset () {
      this.startDate = null
      this.endDate = null
      this.callApi()
    },
    filter () {
      const datesFilled = (this.endDate && this.startDate)

      if ((this.startDate || this.endDate) && !datesFilled) {
        Event.$emit('showModal', 'Es necesario rellenar la fecha de inicio y fin de la consulta')
        return
      }

      if (this.startDate && this.endDate < this.startDate) {
        Event.$emit('showModal', 'La fecha fin no puede ser menor a la de inicio')
        return
      }

      this.callApi()
    },
    isActiveTab (tab) {
      return this.activeTab === tab
    },
    showTab (tab) {
      this.activeTab = tab
    },
    getKPICountBy (field, value) {
      const isArray = Array.isArray(value)

      return this.kpis.filter(kpi => isArray ? value.includes(kpi[field]) : kpi[field] === value).length
    },
    setPlatformsCount () {
      this.platformTypes.forEach(platform => {
        this.platforms.push({
          key: platform.key,
          name: platform.name,
          count: this.getKPICountBy('platform', platform.key)
        })
      })
      this.platforms.push({
        name: 'Total',
        count: this.platforms.map(platform => platform.count).reduce((a, b) => a + b, 0)
      })
    },
    setPlatformsPieData () {
      this.platformPieData = [['Plataforma', 'Número']]

      this.platforms.forEach(platform => {
        platform.name !== 'Total' && this.platformPieData.push([platform.name, platform.count])
      })
    },
    setPlatformsChartData () {
      const cols = ['Date']

      this.platforms.forEach(platform => {
        platform.name !== 'Total' && cols.push(platform.name)
      })

      this.platformChartData = [cols]
      this.platformTotalChartData = [['Date', 'Total']]

      const dates = this.kpis.map(kpi => kpi.date).filter((value, index, self) => self.indexOf(value) === index)

      dates.forEach(date => {
        let row = [date]
        const kpis = this.kpis.filter(kpi => kpi.date === date)

        const getKPICountBy = (value) => {
          const isArray = Array.isArray(value)

          return kpis.filter(kpi => isArray ? value.includes(kpi.platform) : kpi.platform === value).length
        }

        this.platforms.forEach(platform => {
          platform.name !== 'Total' && row.push(getKPICountBy(platform.key))
        })

        this.platformChartData.push(row)
        this.platformTotalChartData.push([date, kpis.length])
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Kpis.vue